import ReactSelect from "react-select";
import React from "react";
const customStyles = {
  control: (base: any, state: any) => ({
    ...base,
    height: "55px",
    minHeight: "24px",
    overflow: "auto",
  }),
};

const Select = (props: any) => {
  return (
    <ReactSelect
      options={props.options}
      name={props.name}
      isMulti={props.isMulti}
      isDisabled={props.isDisabled}
      onChange={props.onChange}
      defaultValue={props.defaultValue}
      styles={customStyles}
      value={props.value}
      theme={(theme: any) => ({
        ...theme,

        colors: {
          ...theme.colors,
          // primary25: "#2978ca",
          primary: "#b3e5fc",
          // primary50: "#2978ca"
        },
      })}
    />
  );
};

export { Select };
